// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import {Fragment} from 'react';
import {Image} from '@shopify/hydrogen';
import MenuClose from '../icons/MenuClose';

type Props = {
  heading?: string;
  open: boolean;
  onClose: () => void;
  openFrom: 'right' | 'left';
  children: React.ReactNode;
};

function Drawer({heading, open, onClose, openFrom = 'right', children}: Props) {
  const offScreen = {
    right: 'translate-x-full',
    left: '-translate-x-full',
  };

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 left-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0">
          <div className="absolute inset-0 overflow-hidden">
            <div
              className={`fixed inset-y-0 flex max-w-full overflow-y-scroll ${
                openFrom === 'right' ? 'right-0' : ''
              }`}
            >
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom={offScreen[openFrom]}
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo={offScreen[openFrom]}
              >
                <Dialog.Panel className="h-screen min-h-screen w-screen max-w-lg transform bg-white text-left align-middle shadow-xl transition-all">
                  <header
                    className={`sticky flex items-center border-b border-gray-200 bg-foam-100 px-6 py-6 sm:px-8 md:px-12 ${
                      heading ? 'justify-between' : 'justify-end'
                    }`}
                  >
                    <button
                      type="button"
                      className="-m-4 p-4 text-primary transition hover:text-primary/50"
                      onClick={onClose}
                    >
                      <MenuClose />
                    </button>
                    <div className="h-full">
                      <a
                        className="flex h-full flex-col justify-center text-3xl font-black"
                        href="/"
                      >
                        <Image
                          src={`/images/logo-full.png`}
                          alt="TFR Logo"
                          width={180}
                          height={12}
                        />
                      </a>
                    </div>
                    <div></div>
                  </header>
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

/* Use for associating arialabelledby with the title*/
Drawer.Title = Dialog.Title;

export {Drawer};
